import React, { useState, useEffect } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Button,
    CardTitle,
    CardSubtitle,
    Label,
    Input,
    Container,
    Form,
    FormFeedback,
    UncontrolledAlert,
    Spinner // Import Spinner component for loading indicator
} from "reactstrap";
import { useParams, useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import { useFormik } from "formik";
import { get, put, del } from "../../Services/RestAPIService";
import { withTranslation } from 'react-i18next';
import Breadcrumbs from "../../components/Common/Breadcrumb";
import AlertModal from "../../components/AlertModal";
import Select from "react-select";

const ExerciseForm = ({ t }) => {
    const navigate = useNavigate();
    const [exerciseData, setExerciseData] = useState(null);
    const [exerciseImage, setExerciseImage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingdel, setIsLoadingdel] = useState(false);
    const [videoLink, setVideoLink] = useState('');
    const [videoPlatform, setVideoPlatform] = useState('YouTube');
    const [dataOriginal, setDataOriginal] = useState([]);

    const [selectedCategories, setSelectedCategories] = useState([]); // for multiple parent categories
    const [subcategoriesMap, setSubcategoriesMap] = useState({}); // { parentId: [subcategories] }
    const [selectedSubcategories, setSelectedSubcategories] = useState([]); // { parentId: [selectedSubcategories] }


    const [alert, setAlert] = useState({
        color: "",
        message: "",
        visible: false
    });
    const { subid,id } = useParams();
    const [isAlertModal, setIsAlertModal] = useState(false); // State to Display Modal for delete confirmation

    const getExerciseData = async () => {
        try {
            const data = await get(`exercise/exercises/${id}/`);
            console.log(data, "DATAA")
            setExerciseData(data);
            if (data.image) {
                // setExerciseImage(data.image);
            }
            if (data.video_link) {
                setVideoLink(data.video_link);
            }
            if (data.video_platform) {
                setVideoPlatform(data.video_platform);
            }
            getUsersData(data);
        } catch (error) {
            console.error('Error fetching exercise data:', error);
        }
    };

    useEffect(() => {
        getExerciseData();
   
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            exercise_name: exerciseData ? exerciseData.exercise_name : '',
            monthly: exerciseData ? exerciseData.monthly : 0,
            yearly: exerciseData ? exerciseData.yearly : 0,
            weekly: exerciseData ? exerciseData.weekly : 0,
            once: exerciseData ? exerciseData.once : 0,
            description: exerciseData ? exerciseData.description : '',
            status: exerciseData ? exerciseData.status : false,
            image: '',
            videoLink: videoLink
        },
        validationSchema: Yup.object({
            exercise_name: Yup.string().required(t("Please Enter Exercise Name")),
            description: Yup.string().required(t("Please Enter Description")),
            // videoLink: Yup.string().url("Invalid URL format").required("Please Enter Video Link"),

        }),
        onSubmit: async (values) => {
            console.log(values,"values")
            setIsLoading(true);

            const categoryIds = Object.values(selectedSubcategories)
            .flat()
            .map((item) => Number(item.value));
            
            const Data = {
                "exercise_name": values.exercise_name,
                "monthly": values.monthly,
                "yearly": values.yearly,
                "weekly": values.weekly,
                "once": values.once,
                "description": values.description,
                "status": values.status,
                "video_link": videoLink,
                "video_platform": videoPlatform,
                "categories":categoryIds,
                ...(exerciseImage && { "image": exerciseImage })
            }
            try {
                const response = await put(`exercise/exercises/${id}/`, Data, {
                    headers: { 'Content-Type': 'application/json' },
                    validateStatus: false
                });
                if (response.status !== 400) {
                    setAlert({
                        color: "success",
                        visible: true,
                        message: t("exerciseUpdatedSuccessfully")
                    });
                    setTimeout(() => {
                        setAlert({ visible: false });
                    }, 3000);
                } else {
                    let errorMessage = t("errorUpdatingExercise");
                    for (const key in response.data) {
                        if (Array.isArray(response.data[key]) && response.data[key].length > 0) {
                            errorMessage = `${key}: ${response.data[key][0]}`;
                            break;
                        }
                    }
                    setAlert({
                        color: "danger",
                        visible: true,
                        message: errorMessage
                    });
                }
            } catch (error) {
                console.error('Error updating user data:', error);
                setAlert({
                    color: "danger",
                    visible: true,
                    message: t("errorUpdatingExercise")
                });
                setTimeout(() => {
                    setAlert({ visible: false });
                }, 3000);
            } finally {
                setIsLoading(false);
            }
        }
    });

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          const reader = new FileReader();
          reader.onloadend = () => {
            const base64String = reader.result;
            setExerciseImage(base64String); // Assuming setProfileImage is a state setter function
            // validation.setFieldValue('image', file);
          };
          reader.readAsDataURL(file);
        }
    };

    const handleDeleteExercise = async () => {
        try {
            setIsLoadingdel(true);
            const response = await del(`exercise/exercises/${id}/`);
            if (response.status <= 400) {
                setAlert({
                    color: "success",
                    visible: true,
                    message: "exerciseDeletedSuccessfully"
                });
                setTimeout(() => {
                    navigate(`/category/exercise/${subid}/${exerciseData?.category_id?.id}`)
                         }, 1500);

            } else {
                setAlert({
                    color: "danger",
                    visible: true,
                    message: t("errorDeletingExercise")
                });
            }
        } catch (error) {
            console.error('Error deleting exercise:', error);
            setAlert({
                color: "danger",
                visible: true,
                message: t("errorDeletingExercise")
            });

        } finally {
            setTimeout(() => {
                setAlert({ visible: false });
            }, 3000);
            setIsAlertModal(false)
            setIsLoadingdel(false);
        }
    };


    const getUsersData = async (data) => {

        console.log("FFF")
        try {
          const usersData = await get(`category/categories/?parent_id_isnull=true`);

          console.log(usersData,"usersData")

          if (usersData) {
            const formatted = usersData.results.map(category => ({
              label: category.name,
              value: category.id.toString(),
            }));
            

            // usersData.results.forEach((category) => {
            //     data.categories.forEach((InCategory) => {
            //       if (category.id.toString() === InCategory.id) {
            //         setSelectedCategories((prev) => ({
            //           ...prev,
            //           [category.id]: {
            //             label: category.name,
            //             value: category.id.toString(),
            //           },
            //         }));
            //       }
            //     });
            //   });
            let selected = [];

            usersData.results.forEach((user) => {
                data.parent_categories.forEach((category) => {
                  if (user.id.toString() === category.id.toString()) {
                    selected.push({
                      label: category.name,
                      value: category.id.toString(),
                    });
                  }
              });
            });

                    // setSelectedCategories((prev) => ({
                    //   ...prev,
                    //   [category.id]: {
                    //     label: category.name,
                    //     value: category.id.toString(),
                    //   },
                    // }));



            // const selected = usersData.results.map((category) => ({
            //     label: category.name,
            //     value: category.id.toString(),
            //   }));
              
              handleParentChange(selected,data);
    
            setDataOriginal(formatted);
          }
        } catch (error) {
          console.error("Error fetching categories", error);
        }
      };




    const fetchSubcategories = async (parentId,data) => {

        // console.log(parentId,data,"parentId,selected")
        console.log(data,",selected")

        try {
          const res = await get(`category/categories/?parent_id=${parentId}`);
          const formatted = res.results.map(sub => ({
            label: sub.name,
            value: sub.id.toString(),
          }));
          console.log(res,"RESSS")
          res.results.forEach((category) => {
            data?.categories?.forEach((InCategory) => {
              if (category?.id?.toString() === InCategory.id?.toString()) {
                setSelectedSubcategories((prev) => {
                  const existing = prev[parentId] || [];
                  const newItem = { label: category.name, value: category?.id?.toString() };
          
                  // Avoid duplicates (optional)
                  const alreadyExists = existing.some(item => item.value === newItem.value);
                  if (alreadyExists) return prev;
          
                  return {
                    ...prev,
                    [parentId]: [...existing, newItem],
                  };
                });
              }
            });
          });
    
          setSubcategoriesMap(prev => ({
            ...prev,
            [parentId]: formatted,
          }));
        } catch (err) {
          console.error("Subcategories fetch failed", err);
        }
      };


    const handleParentChange = (selected,data) => {

        console.log(selected,"selected"
        )
        setSelectedCategories(selected);
      
        selected.forEach((cat) => {
          if (!subcategoriesMap[cat.value]) {
            fetchSubcategories(cat.value,data);
          }
        });
      
        // Remove any unselected categories from selectedSubcategories
        const updated = {};
        selected.forEach((cat) => {
          if (selectedSubcategories[cat.value]) {
            updated[cat.value] = selectedSubcategories[cat.value];
          }
        });
        setSelectedSubcategories(updated);
        console.log(selectedCategories)
      };


    // Video

    const handleVideoLinkChange = (event) => {
        // Step 3: Function to handle changes in video link input
        setVideoLink(event.target.value);
        validation.setFieldValue('videoLink', event.target.value);
    };


    const handleVideoPlatformChange = (event) => {
        setVideoPlatform(event.target.value);
    };


    const getVideoEmbedUrl = (platform, link) => {
        console.log(platform, link, "platform, link")

        switch (platform) {
            case 'YouTube':

                return `https://www.youtube.com/embed/${encodeURIComponent(getYoutubeVideoId(link))}?si=9552mlr0hYutmQ9k`;

            //  return <iframe width="560" height="315" src={`https://www.youtube.com/embed/${link}?si=9552mlr0hYutmQ9k`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            case 'Vimeo':
                return `https://player.vimeo.com/video/${getVimeoVideoId(link)}?h=3eb6a365ec`;
            case 'Dailymotion':
                return `https://www.dailymotion.com/embed/video/${getDailymotionVideoId(link)}`;
            case 'Wistia':
                return `https://fast.wistia.net/embed/iframe/${getWistiaVideoId(link)}`;
            default:
                return '';
        }
    };


    const getYoutubeVideoId = (link) => {
        // Regular expression to match YouTube video ID
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        // Match the regular expression against the input link
        const match = link.match(regex);
        // If a match is found, return the video ID, otherwise return an empty string
        return match ? match[1] : '';
    };


    const getVimeoVideoId = (link) => {
        // Regular expression to match Vimeo video ID
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:vimeo\.com\/)([0-9]+)/;
        // Match the regular expression against the input link
        const match = link.match(regex);
        // If a match is found, return the video ID, otherwise return an empty string
        return match ? match[1] : '';
    };

    return (
        <React.Fragment>
            {alert.visible && <UncontrolledAlert className="Alert_Additions_Log" color={alert.color}>{alert.message}</UncontrolledAlert>}
            {isAlertModal && (
                <AlertModal

                    selection={(e) => { e === true ? handleDeleteExercise() : setIsAlertModal(false) }} Display={null}
                // message="Are you sure you want to delete this exercise?"
                // onConfirm={() => { setIsAlertModal(false); handleDeleteExercise(); }}
                // onCancel={() => setIsAlertModal(false)}
                />
            )}
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs maintitle={t("Home")} title={t("Exercises")}
                    titleLink={exerciseData ?`/category/exercise/${subid}/${exerciseData?.category_id?.id}`:"navigate"} 
                    breadcrumbItem={t("Exercise Details")} />
                    <Row>
          

                        <Col lg={3}>
                            <Card>
                                <CardBody>


                                    <div className="text-center">
                                        <img src={exerciseImage || exerciseData?.image || 'https://dummyimage.com/600x400/000/fff'} alt="Exercise" className="img-thumbnail" style={{ height: "200px", maxWidth: '100%' }} />
                                    </div>
                                    <div className="text-center mt-3">
                                        <input
                                            type="file"
                                            id="file"
                                            style={{ display: "none" }}
                                            onChange={handleImageChange}
                                        />
                                        <label htmlFor="file" className="btn btn-primary">
                                        {t("Change Image")}
                                        </label>
                                    </div>


                                    {/* <div className="text-center">
                                        <img src={exerciseImage || 'https://dummyimage.com/600x400/000/fff'} alt="Exercise" className="img-thumbnail" style={{ height: "200px", maxWidth: '100%' }} />
                                    </div>
                                    <div className="text-center mt-3">
                                        <input
                                            type="file"
                                            id="file"
                                            style={{ display: "none" }}
                                            onChange={handleImageChange}
                                        />
                                        <label className="btn ">
                                            Video Preview
                                        </label>
                                    </div> */}


                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={9}>
                            <Card>
                                <CardBody>
                                    <CardTitle>{t("editExercise")}</CardTitle>
                                    <CardSubtitle className="mb-3">
                                    {t("editExerciseSubtitle")}
                                    </CardSubtitle>
                                    <Form onSubmit={validation.handleSubmit}>



                                    <FormGroup className="mb-3">

                                        <Label className="form-label">{t('Select Parent Category')}</Label>
                                        <Select
                                        isMulti
                                        name="parentCategories"
                                        value={selectedCategories}
                                        options={dataOriginal}
                                        onChange={handleParentChange}
                                        // value={selectedData}
                                        // name="categorySelected"
                                        // onChange={(selectedOption) => {
                                        //   console.log(selectedOption,"selectedOption")
                                        //   setSelectedData(selectedOption);
                                        //   validation.setFieldValue('categorySelected', selectedOption); // Set formik value
                                        //   getSubcatData(Number(selectedOption?.value));
                                        // }}
                                        onBlur={validation.handleBlur}
                                        // options={dataOriginal}
                                        classNamePrefix="select2-selection"
                                        />
                                        {validation.touched.categorySelected && validation.errors.categorySelected && (
                                        <FormFeedback type="invalid">{validation.errors.categorySelected}</FormFeedback>
                                        )}
                                        </FormGroup>

                                        {/* ff */}


                                        {selectedCategories.map((cat) => (
                                        <FormGroup key={cat.value} className="mb-3">
                                            <Label>
                                            {t("Select Body Parts for")} <strong>{cat.label}</strong>
                                            </Label>
                                            <Select
                                            isMulti
                                            name={`bodyParts-${cat.value}`}
                                            options={subcategoriesMap[cat.value] || []}
                                            value={selectedSubcategories[cat.value] || []}
                                            onChange={(selected) =>[
                                                console.log(selectedSubcategories),
                                                setSelectedSubcategories(prev => ({
                                                ...prev,
                                                [cat.value]: selected,
                                                }))
                                            ]}
                                            />
                                        </FormGroup>
                                        ))}




                                        <div className="mb-3">
                                        <Label className="form-label">{t("Exercise Name")}</Label>

                                            <Input
                                                name="exercise_name"
                                                type="text"
                                                // placeholder={t("Enter exercise name")}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.exercise_name || ""}
                                                invalid={validation.touched.exercise_name && validation.errors.exercise_name}
                                            />
                                            {validation.touched.exercise_name && validation.errors.exercise_name && (
                                                <FormFeedback type="invalid">{validation.errors.exercise_name}</FormFeedback>
                                            )}
                                        </div>


                                        <div className="mb-3">
                                            <Label className="form-label">{t("Description")}</Label>
                                            <Input
                                                type="textarea"
                                                name="description"
                                                rows="5"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.description || ""}
                                                invalid={validation.touched.description && validation.errors.description}
                                            />
                                            {validation.touched.description && validation.errors.description && (
                                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                            )}
                                        </div>


                                        {/* Video */}

                                        {/* <div className="mb-3">
                                            <Label className="form-label">Select Video Platform</Label>
                                            <Input
                                                type="select"
                                                name="videoPlatform"
                                                onChange={handleVideoPlatformChange}
                                                value={videoPlatform}
                                            >
                                                <option value="YouTube">YouTube</option>
                                                <option value="Vimeo">Vimeo</option>
                                              
                                            </Input>
                                        </div> */}

                                        {/* <div className="mb-3">
                                            <Label className="form-label">Video Link</Label>
                                            <span className="text-muted">    Enter {videoPlatform} video link:</span>
                                            <Input
                                                type="text"
                                                name="videoLink"
                                                onChange={handleVideoLinkChange}
                                                onBlur={validation.handleBlur}
                                                value={videoLink}
                                                invalid={validation.touched.videoLink && validation.errors.videoLink}
                                            />
                                            {validation?.touched?.videoLink && validation?.errors?.videoLink && (
                                                <FormFeedback type="invalid">{validation?.errors?.videoLink}</FormFeedback>
                                            )}
                         
                                            {videoLink && (
                                                <div className="mt-3">
                                                    <iframe
                                                        width="100%"
                                                        height="200"
                                                        src={getVideoEmbedUrl(videoPlatform, videoLink)}
                                                        frameBorder="0"
                                                        allowFullScreen
                                                        title="Video Preview"
                                                    ></iframe>
                                                </div>
                                            )}
                                        </div> */}

                                        {/* END */}

                                        {/* <div className="mb-3">
                                            <Label className="form-label">Monthly</Label>
                                            <Input
                                                type="number"
                                                name="monthly"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.monthly || ""}
                                                invalid={validation.touched.monthly && validation.errors.monthly}
                                            />
                                            {validation.touched.monthly && validation.errors.monthly && (
                                                <FormFeedback type="invalid">{validation.errors.monthly}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Yearly</Label>
                                            <Input
                                                type="number"
                                                name="yearly"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.yearly || ""}
                                                invalid={validation.touched.yearly && validation.errors.yearly}
                                            />
                                            {validation.touched.yearly && validation.errors.yearly && (
                                                <FormFeedback type="invalid">{validation.errors.yearly}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Weekly</Label>
                                            <Input
                                                type="number"
                                                name="weekly"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.weekly || ""}
                                                invalid={validation.touched.weekly && validation.errors.weekly}
                                            />
                                            {validation.touched.weekly && validation.errors.weekly && (
                                                <FormFeedback type="invalid">{validation.errors.weekly}</FormFeedback>
                                            )}
                                        </div>

                                        <div className="mb-3">
                                            <Label className="form-label">Once</Label>
                                            <Input
                                                type="number"
                                                name="once"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.once || ""}
                                                invalid={validation.touched.once && validation.errors.once}
                                            />
                                            {validation.touched.once && validation.errors.once && (
                                                <FormFeedback type="invalid">{validation.errors.once}</FormFeedback>
                                            )}
                                        </div> */}

                                        <div className="mb-3">
                                            <Label className="form-label">{t("Status")}</Label>
                                            <Input
                                                type="select"
                                                name="status"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.status || false}
                                                invalid={validation.touched.status && validation.errors.status}
                                            >
                                                <option value={true}> {t("Active")}</option>
                                                <option value={false}> {t("Inactive")}</option>
                                            </Input>
                                            {validation.touched.status && validation.errors.status && (
                                                <FormFeedback type="invalid">{validation.errors.status}</FormFeedback>
                                            )}
                                        </div>




                                        <div className="d-flex flex-wrap gap-2">
                                            <Button type="submit" color="primary" disabled={isLoading || isLoadingdel}>
                                                {isLoading ? <Spinner size="sm" color="light" /> : t("Submit")}
                                            </Button>{" "}
                                            <Button type="button" color="danger" onClick={() => setIsAlertModal(true)} disabled={isLoading || isLoadingdel}>
                                                {isLoadingdel ? <Spinner size="sm" color="light" /> : t("Delete")}
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};


export default withTranslation()(ExerciseForm);